import { CSSProperties } from 'react';

export const giftActionButtonStyle: CSSProperties = {
  width: '100%',
  height: '50px',
  color: '#000',
  border: 'none',
  borderRadius: '45px',
  fontSize: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 'none',
  textAlign: 'center',
  appearance: 'none',
  fontWeight: 500,
  margin: '5px'
};
